import styled from '@emotion/styled'
import {
  Box,
  Stepper as MuiStepper,
  StepLabel as MuiStepLabel,
} from '@mui/material'
import { colors, typography, Button } from '@resiliatech/birdsong'

export const FullWindowContainer = styled(Box)`
  align-items: center;
  background-color: ${colors.background.primaryBackground};
  display: flex;
  flex-direction: column;
  height: 100vh;
  justify-content: space-between;
`

export const Header = styled(Box)`
  align-items: center;
  background: #0a2756;
  display: flex;
  justify-content: space-between;
  min-height: 70px;
  padding: 0 24px;
  width: 100%;
`

export const StepperContent = styled(Box)`
  flex: 1;
  max-width: 1000px;
  min-width: 600px;
  margin: 0 48px;
  display: flex;
  align-items: center;
`

export const StyledStepLabel = styled(MuiStepLabel)`
  .MuiStepLabel-labelContainer {
    margin-top: 0;
  }

  .MuiStepLabel-label {
    ${typography.baseline.regularSans};
    color: rgba(255, 255, 255, 0.5);
    font-size: 14px;
    line-height: 20px;
    font-weight: 400;
    text-transform: none;
    white-space: nowrap;

    &.Mui-active {
      color: white;
      font-weight: 500;
    }

    &.Mui-completed {
      color: white;
    }
  }

  .MuiStepLabel-iconContainer {
    padding-right: 8px;
  }
`

export const StyledStepper = styled(MuiStepper)`
  background: transparent;
  width: 100%;

  .MuiStep-root {
    padding: 0 8px;
    &:first-of-type {
      padding-left: 0;
    }
    &:last-of-type {
      padding-right: 0;
    }
  }

  .MuiStepIcon-root {
    color: rgba(255, 255, 255, 0.5);
    width: 20px;
    height: 20px;
    margin-top: 2px;

    &.Mui-active {
      color: #90caf9;

      .MuiStepIcon-text {
        fill: #0a2756;
        font-weight: 500;
      }
    }

    &.Mui-completed {
      color: #90caf9;

      .MuiStepIcon-text {
        fill: white;
      }
    }

    .MuiStepIcon-text {
      ${typography.baseline.regularSans};
      fill: rgba(255, 255, 255, 0.87);
      font-size: 12px;
    }
  }

  .MuiStepConnector-root {
    left: calc(-50% + 18px);
    right: calc(50% + 18px);
    top: 10px;

    .MuiStepConnector-line {
      border-color: rgba(255, 255, 255, 0.5);
      border-top-width: 1px;
    }

    &.Mui-active .MuiStepConnector-line,
    &.Mui-completed .MuiStepConnector-line {
      border-color: #90caf9;
    }
  }
`

export const SignOut = styled(Button)`
  ${typography.baseline.regularSans};
  color: white;
  text-transform: none;
  padding: 4px 16px;
  min-width: unset;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 4px;

  &:hover {
    background-color: rgba(255, 255, 255, 0.2);
  }
`
